import { useLayoutStyle } from '@/contexts/ThemeContext';
import type { SectionData } from './SectionRenderer';
import { SectionRenderer } from './SectionRenderer';

/**
 * Renders the optional page-builder blocks an owner added to a built-in page
 * (e.g. "Leave a review"). Pass the result of usePageExtraSections so the page
 * can also react to which blocks exist (the homepage links to the review form).
 */
export function PageExtraSections({ sections }: { sections: SectionData[] | undefined }) {
  const layoutStyle = useLayoutStyle();
  if (!sections?.length) return null;

  return (
    <>
      {sections.map((section) => (
        <SectionRenderer key={section.id} section={section} layoutStyle={layoutStyle} />
      ))}
    </>
  );
}
